module.exports = __webpack_public_path__ + "media/co-op.8ea77480.mp4";